import axios from 'axios'
import { reloadPage } from '../../plugins/reload-page'

const getAllReports = (baseUrl, page, signalToken) => {
  const getAllReports = new Promise(function (resolve, reject) {
    const url = `${baseUrl}/api/tasks?page=${page}`
    axios
      .get(url, {
        cancelToken: signalToken,
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('access')}`,
          'X-User': localStorage.getItem('selectedUserId') || null,
        },
      })
      .then((res) => {
        if (res?.status === 200) {
          resolve(res)
        } else throw new Error()
      })
      .catch((e) => {
        if (e?.response?.status === 401) {
          reloadPage(e)
          return
        }

        if (e?.__proto__?.__CANCEL__) {
          return
        }

        reject({ errorMessage: <>Ошибка сервера, обновляем данные...</> })
      })
  })
  return getAllReports
}

export { getAllReports }
